"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[216],{

/***/ 5216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Base; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 1 modules
var useCookies = __webpack_require__(708);
// EXTERNAL MODULE: ./node_modules/@typeform/embed-react/build/index.js
var build = __webpack_require__(2606);
;// CONCATENATED MODULE: ./components/navigation/desktop.jsx
/* eslint-disable @next/next/no-img-element */ 





function Desktop(param) {
    let { setOpen  } = param;
    let current = (0,router.useRouter)().pathname.split("/")[1];
    const [cookies, _] = (0,useCookies/* default */.Z)([
        "ref"
    ]);
    const [ref, setRef] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (cookies.ref) setRef(cookies.ref);
    }, [
        cookies
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: "border-b border-gray-200 top-0 bg-white sticky z-[60]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "hidden lg:flex flex-row gap-12 items-center justify-between max-w-7xl mx-auto py-4 px-6 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                    href: "/",
                    className: "flex flex-row gap-2 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "h-11 w-auto ",
                            src: "/logo.png",
                            alt: "JackRabbit orange rabbit"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm text-jackOrange font-header mt-2",
                            children: "Jackrabbit Ops"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-8 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row gap-8 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " ".concat(current == "features" ? "text-[#F6800A]" : "text-gray-700", " hover:text-[#F6800A]"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/#features",
                                            children: "Features"
                                        }),
                                        current == "features" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "translate-y-7 -mt-1 pb-1 w-full bg-gradient-to-r from-[#F6800A]/20 via-[#F6800A]/60 to-[#F6800A]/20"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " ".concat(current == "price" ? "text-[#F6800A]" : "text-gray-700", " hover:text-[#F6800A]"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/#price",
                                            children: "Pricing"
                                        }),
                                        current == "price" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "translate-y-7 -mt-1 pb-1 w-full bg-gradient-to-r from-[#F6800A]/20 via-[#F6800A]/60 to-[#F6800A]/20"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " ".concat(current == "blog" ? "text-[#F6800A]" : "text-gray-700", " hover:text-[#F6800A]"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/blog",
                                    children: "Blog"
                                }),
                                current == "blog" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "translate-y-7 -mt-1 pb-1 w-full bg-gradient-to-r from-[#F6800A]/20 via-[#F6800A]/60 to-[#F6800A]/20"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "https://sdr.jackrabbitops.com/register",
                            className: "border border-gray-800 hover:text-gray-900 rounded-md px-6 py-2 bg-gray-900 text-white hover:bg-white",
                            children: "Get Access - 2mins"
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js + 1 modules
var popover = __webpack_require__(9860);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(4829);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/XMarkIcon.js
var XMarkIcon = __webpack_require__(1415);
;// CONCATENATED MODULE: ./components/navigation/hamburger.jsx







function Example(param) {
    let { setOpen  } = param;
    const [cookies, _] = (0,useCookies/* default */.Z)([
        "ref"
    ]);
    const [ref, setRef] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (cookies.ref) setRef(cookies.ref);
    }, [
        cookies
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: " lg:hidden top-0 bg-black sticky z-[60] ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "min-h-full ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
                as: "header",
                children: (param)=>/*#__PURE__*/ {
                    let { open  } = param;
                    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row justify-between lg:hidden p-4 bg-white border-b border-gray-300 items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "h-10 w-auto mx-auto",
                                            src: "/logo.png",
                                            alt: "JackRabbit orange rabbit"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://sdr.jackrabbitops.com/register",
                                        className: "border border-gray-800 hover:text-gray-900 rounded-md px-6 py-2 bg-gray-900 text-white hover:bg-white",
                                        children: "Get Access - 2mins"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
                                as: react.Fragment,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "lg:hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                                            as: react.Fragment,
                                            enter: "duration-150 ease-out",
                                            enterFrom: "opacity-0",
                                            enterTo: "opacity-100",
                                            leave: "duration-150 ease-in",
                                            leaveFrom: "opacity-100",
                                            leaveTo: "opacity-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Overlay */.J.Overlay, {
                                                className: "fixed inset-0 z-20 bg-black bg-opacity-25"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                                            as: react.Fragment,
                                            enter: "duration-150 ease-out",
                                            enterFrom: "opacity-0 scale-95",
                                            enterTo: "opacity-100 scale-100",
                                            leave: "duration-150 ease-in",
                                            leaveFrom: "opacity-100 scale-100",
                                            leaveTo: "opacity-0 scale-95",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                                                focus: true,
                                                className: "absolute inset-x-0 top-0 z-30 mx-auto w-full max-w-3xl origin-top transform p-2 transition",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "divide-y divide-gray-200 rounded-lg bg-black shadow-lg ring-1 ring-black ring-opacity-5 z-40",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "pt-3 pb-2 z-40",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex items-center justify-between px-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            className: "h-14 w-auto ",
                                                                            src: "/logo.png",
                                                                            alt: "JackRabbit orange rabbit"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "-mr-2",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                                            className: "inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-600",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "sr-only",
                                                                                    children: "Close menu"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XMarkIcon/* default */.Z, {
                                                                                    className: "h-6 w-6",
                                                                                    "aria-hidden": "true"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "mt-12 space-y-1 px-2",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex-row gap-8 items-center ml-3 text-lg ",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "text-gray-300 hover:text-black mb-4",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/features",
                                                                                children: "AI Manger Features"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "text-gray-300 hover:text-black mb-4",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/price",
                                                                                children: "Pricing"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "text-gray-300 hover:text-black mb-4",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/blog",
                                                                                children: "Blog"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "text-gray-300 hover:text-black mb-4",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/90-day-challenge",
                                                                                children: "90 Day Challenge"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "relative group mb-4 w-max",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "absolute -inset-0.5 bg-gradient-to-r from-white to-gray-200 rounded-lg blur opacity-40 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-tilt"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: "https://app.jackrabbitops.com/register".concat(ref ? "?ref=".concat(ref) : ""),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                        className: "relative px-5 py-3 bg-black rounded-lg leading-none flex items-center divide-x divide-gray-600",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "text-gray-300 group-hover:text-gray-100 transition duration-200",
                                                                                            children: "Try Free →"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/footer/index.jsx

const navigation = [
    {
        name: "LinkedIn",
        style: "h-6 w-6",
        href: "https://www.linkedin.com/company/jackrabbit-ops",
        icon: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                fill: "currentColor",
                viewBox: "0 0 24 24",
                ...props,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z",
                    clipRule: "evenodd"
                })
            })
    },
    {
        name: "Twitter",
        style: "h-6 w-6",
        href: "https://twitter.com/jackrabbitops",
        icon: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                fill: "currentColor",
                viewBox: "0 0 24 24",
                ...props,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
                })
            })
    },
    {
        name: "Discord",
        style: "h-8 w-8",
        href: "https://discord.gg/vBpqvRWjpZ",
        icon: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                fill: "currentColor",
                viewBox: "0 0 24 24",
                ...props,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z"
                })
            })
    },
    {
        name: "Youtube",
        style: "-ml-2 h-6 w-6",
        href: "https://www.youtube.com/@jackrabbitops",
        icon: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                fill: "currentColor",
                viewBox: "0 0 310 310",
                ...props,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "XMLID_823_",
                    d: "M297.917,64.645c-11.19-13.302-31.85-18.728-71.306-18.728H83.386c-40.359,0-61.369,5.776-72.517,19.938 C0,79.663,0,100.008,0,128.166v53.669c0,54.551,12.896,82.248,83.386,82.248h143.226c34.216,0,53.176-4.788,65.442-16.527 C304.633,235.518,310,215.863,310,181.835v-53.669C310,98.471,309.159,78.006,297.917,64.645z M199.021,162.41l-65.038,33.991 c-1.454,0.76-3.044,1.137-4.632,1.137c-1.798,0-3.592-0.484-5.181-1.446c-2.992-1.813-4.819-5.056-4.819-8.554v-67.764 c0-3.492,1.822-6.732,4.808-8.546c2.987-1.814,6.702-1.938,9.801-0.328l65.038,33.772c3.309,1.718,5.387,5.134,5.392,8.861 C204.394,157.263,202.325,160.684,199.021,162.41z"
                })
            })
    }
];
function Footer() {
    const year = new Date().getFullYear();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "bg-black border-t border-gray-800 ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto max-w-7xl py-12 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center space-x-6 md:order-2",
                    children: navigation.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: item.href,
                            rel: "noreferrer",
                            target: "_blank",
                            className: "text-gray-400 hover:text-gray-500",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: item.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                    className: item.style,
                                    "aria-hidden": "true"
                                })
                            ]
                        }, item.name))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-gray-400",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-8 md:order-1 md:mt-0 flex flex-row gap-2 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: "https://www.castleclock.com/",
                                    rel: "noreferrer",
                                    target: "_blank",
                                    className: " text-gray-400 hover:text-gray-700",
                                    children: [
                                        "\xa9 ",
                                        year,
                                        " Jackrabbit Ops, Inc."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-center text-base text-gray-400",
                                    children: "All rights reserved."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            rel: "noreferrer",
                            target: "_blank",
                            href: "/terms",
                            className: "text-sm text-gray-400 hover:text-gray-700",
                            children: "Terms & Conditions"
                        }),
                        " | ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            rel: "noreferrer",
                            target: "_blank",
                            href: "/privacy",
                            className: "text-sm text-gray-400 hover:text-gray-700",
                            children: "Privacy Policy"
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/container/base.jsx
// COMPONENTS




function Base(param) {
    let { setOpen , children , blackOut , noFooter  } = param;
    const style = blackOut ? "bg-black" : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop, {
                setOpen: setOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Example, {
                setOpen: setOpen
            }),
            children,
            !noFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
}


/***/ })

}]);